@import '../../../../../static/less/variables';

.o-invite-page {
  &#content h1 {
    margin-bottom: 45px;
  }
  .c-signup-inline {
    border: 0;
    padding: 0;
    min-height: initial;
  }

  .btn-toolbar {
    margin-top: 45px;
  }
  max-width: 900px;

  .c-signup-form {
    max-width: 700px;
    .tos-section {
      float: left;
      display: block;
      text-align: left;
    }
    .recaptcha-section {
      width: 307px;
      margin-right: 30px;
      float: left;
      display: block;
    }
    .table-row {
      overflow: hidden;
    }
    .g-recaptcha > div {
      border-right: 0 solid #d3d3d3;
    }
  }

  .c-organization-details-form {
    max-width: 710px;
    border: 0;
    padding: 0;
  }

  .data-grid-container {
    width: 850px !important;
  }

  .flex-vertical-wrapper {
    align-items: center;
    display: flex;
  }

  .text-notification {
    flex-grow: 1;
    vertical-align: middle;
    float: left;
    width: 56%;
    padding-left: 50px;
    padding-right: 10px;
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/Invite/components/InvitePage.less